
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.086 13.53a4.578 4.578 0 00-4.516-3.862c-.857 0-1.682.237-2.396.68a6.049 6.049 0 00-5.22-2.965A6.1 6.1 0 005.86 13.54C3.7 13.904 2 15.786 2 18.047c0 2.52 2.1 4.57 4.621 4.57H23.38c2.52 0 4.621-2.05 4.621-4.57 0-2.28-1.728-4.175-3.914-4.516z","fill":"#fff"}})])
          )
        }
      }
    